// import { apiRequest } from "utils/service";
import Header from "components/modules/Header/Header";
// import { useEffect } from "react";

type Props = {
  children: React.ReactNode;
};

const Default = ({ children }: Props) => {
  // useEffect(() => {
  //   apiRequest("profile").then((resp) => {
  //     console.log(resp, "profile response");
  //   });
  // });
  return (
    <main className="bg-blue">
      <Header />
      <div className="wrapper" style={{ marginTop: "70px" }}>
        <div id="content">
          <div className="container-fluid">
            <div className="row">{children}</div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Default;
